export * from './center.component';